// main.js
import { createApp, watch } from "vue";
import App from "./App.vue";
import "@fortawesome/fontawesome-free/css/all.min.css";
import router from "./router";
import store from "./store";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "@/assets/css/theme-colors.css";
import "@/assets/css/global.css";
import "@/assets/css/fonts.css";
import VueCookies from "vue3-cookies";
import i18n from "./i18n";
import AclPlugin from "@/plugins/acl";
import { initEcho } from "../resources/js/echo.js";

const app = createApp(App);

const applyLangDir = (loc) => {
  const ar = loc === "ar";
  document.documentElement.setAttribute("dir", ar ? "rtl" : "ltr");
  document.documentElement.setAttribute("lang", ar ? "ar" : "en");
};

applyLangDir(i18n.global.locale.value);

watch(
  () => i18n.global.locale.value,
  (loc) => {
    localStorage.setItem("locale", loc);
    applyLangDir(loc);
  }
);

app.use(i18n);
app.use(store);
app.use(router);
app.use(AclPlugin);
app.use(VueCookies);

app.use(Toast, {
  timeout: 2500,
  rtl: i18n.global.locale.value === "ar",
  position: "top-right",
});

app.mount("#app");

if (store.state.token && store.state.user) {
  initEcho();
  store.dispatch("loadMyPermissions").catch(() => {});
}
